var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPerdidaSeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#522d8e;}.cls-2{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-perdida-se\xF1al") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_11",
    "data-name": 11
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 170,
    y: 71.17,
    width: 27.47,
    height: 109.9,
    rx: 4.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.28,
    y: 106.49,
    width: 27.47,
    height: 74.57,
    rx: 4.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.57,
    y: 129.65,
    width: 27.47,
    height: 51.42,
    rx: 4.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.85,
    y: 155.36,
    width: 27.47,
    height: 25.71,
    rx: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.56,0A127.56,127.56,0,1,0,255.12,127.56,127.56,127.56,0,0,0,127.56,0Zm0,243.44A115.84,115.84,0,0,1,45.62,45.62l.34-.33L209,210a115.39,115.39,0,0,1-81.47,33.49Zm89.37-42.11L54.66,37.49A115.87,115.87,0,0,1,216.93,201.33Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerdidaSeal);
export default __webpack_public_path__ + "static/media/ic-perdida-señal.e590518ad3b0f8db719372681ab5179c.svg";
export { ForwardRef as ReactComponent };